module.exports = __webpack_public_path__ + "img/placeholder_circle.653bc785.svg";